import { useState } from "react"
import styled from "@emotion/styled"
import { Menu, MenuItem } from "@mui/material"
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";


const DisputeCard = ({ disputes, onClick }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [displayType, setDisplayType] = useState("total")
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (event) => {
    if (event) event.stopPropagation()
    setAnchorEl(null)
  }

  const handleSelect = (type, event) => {
    event.stopPropagation()
    setDisplayType(type)
    handleClose()
  }

  const getDisplayLabel = () => {
    switch (displayType) {
      case "pending":
        return "Pending"
      case "resolved":
        return "Resolved"
      case "rejected":
        return "Rejected"
      default:
        return "Total"
    }
  }

  const getDisplayValue = () => {
    switch (displayType) {
      case "pending":
        return disputes?.pending || 0
      case "resolved":
        return disputes?.resolved || 0
      case "rejected":
        return disputes?.rejected || 0
      default:
        return disputes?.total || 0
    }
  }

  return (
    <Container className="card pointer" onClick={onClick}>
      <Header>
        <div>
          Payment Disputes
          <SubTitle>{getDisplayLabel()}</SubTitle>
        </div>
        <div onClick={handleClick} style={{ cursor: "pointer", fontSize: "10px" }}>
        <MoreHorizIcon />
        </div>
        <Menu anchorEl={anchorEl} open={open} onClose={handleClose} onClick={(e) => e.stopPropagation()}>
          <MenuItem onClick={(e) => handleSelect("total", e)}>Total</MenuItem>
          <MenuItem onClick={(e) => handleSelect("pending", e)}>Pending</MenuItem>
          <MenuItem onClick={(e) => handleSelect("resolved", e)}>Resolved</MenuItem>
          <MenuItem onClick={(e) => handleSelect("rejected", e)}>Rejected</MenuItem>
        </Menu>
      </Header>
      <Body>
        <Count>{getDisplayValue()}</Count>
        {/* No breakdown stats shown for any display type */}
      </Body>
    </Container>
  )
}

const Container = styled("div")`
    min-width: 240px;
    border-radius: 8px;
    box-shadow: rgba(149, 157, 165, 0.3) 0px 8px 24px;
`;

const Header = styled("div")`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.7rem 1rem;
    font-weight: 600;
    font-size: 80%;
    border-bottom: 1px solid var(--card-border);
`

const SubTitle = styled("div")`
`

const Body = styled("div")`
    display: grid;
    padding: 0.9rem 1rem;
    padding-bottom: 1rem;
    small{
        font-size: 70%;
        span{
            margin-left: 0.3rem;
        }
    }`

const Count = styled("div")`

`

const Stats = styled("div")`
  display: grid;
  gap: 5px;
  font-size: 12px;
`

const StatItem = styled("div")`
  display: flex;
  justify-content: space-between;
  
  .label {
    color: #666;
  }
  
  .value {
    font-weight: 600;
  }
  
  .pending {
    color: #f59e0b;
  }
  
  .resolved {
    color: #10b981;
  }
  
  .rejected {
    color: #ef4444;
  }
`

export default DisputeCard
